




































import {Component, Prop, Vue} from 'vue-property-decorator';
import {translate} from '@/services/trans'
import { getHeaderHeight } from '@/services/margin';

@Component
export default class visionForTheWallBauminatorMobile extends Vue {
  @Prop() isMobileView!: boolean;
  @Prop() topPosition!: number;

  public c_x = 0
  public colorOverlay = 0
  public textAnimationDelay = -15
  public marginTop = 0

  mounted() {
    window.addEventListener('scroll', this.onScroll);
    window.addEventListener('resize', this.onResize)
    setTimeout(() => {
      this.setColorOverlay()
    }, 100)

    this.marginTop = getHeaderHeight()

  }

  onResize() {
    this.setColorOverlay()
  }

  setColorOverlay() {
    if (document.getElementById('vision') != null) {
      //@ts-ignore
      this.colorOverlay = document.getElementById('vision').clientHeight
    }
  }


  onScroll(e: any) {
    const element: any = document.getElementById('vision')
    const elementInnerHeight = element.clientHeight
    const pageYOffset = window.pageYOffset
    const innerHeight = window.innerHeight
    const elementTopPosition = element.getBoundingClientRect().top - getHeaderHeight()
    if (elementTopPosition - innerHeight < 0) {
      this.c_x = elementTopPosition / (elementInnerHeight / 100)*3

    }

    this.setColorOverlay()
  }


  trans(key :string){
    return translate(key)
  }


}
